export default __webpack_public_path__ + "static/media/z_wdt_c_0.552e61cc.mp3";